module.exports = __webpack_public_path__ + "static/media/opensans-semibold.18e3c830.woff";